import React from 'react'
import useSWR from 'swr'
import useSWRMutation from 'swr/mutation'
import { useNavigate } from 'react-router-dom'

import OnBoardingHeader from './Header'
import Loading from '../../components/layout/Loading'
import { useI18N } from '../../../libraries/i18n/hook'
import NewsForm from '../../containers/users/NewsForm'
import { getUserPreferences, updateOnboardingCompleted } from '../../../api/users'
import { showLinkedinVerificationBeforeOnBoarding } from '../../../libraries/auth/linkedinVerification'
import { CurrentUserContext } from '../../../libraries/auth'
import { ANALYTICS_EVENTS, useAnalytics } from '../../../libraries/posthog'

const OnboardingNews = () => {
  const { t } = useI18N()
  const navigate = useNavigate()
  const { trackEvent } = useAnalytics()
  const { currentUser, refetchCurrentUser } = React.useContext(CurrentUserContext)
  const { data, isLoading } = useSWR('/users/preferences', getUserPreferences)
  const { trigger: completeOnboarding, isMutating: submitting } = useSWRMutation('/users', updateOnboardingCompleted, { populateCache: true })

  const onSuccess = async () => {
    if(showLinkedinVerificationBeforeOnBoarding(!!currentUser?.onboardingCompleted)) {
      if(!currentUser?.onboardingCompleted) {
        await completeOnboarding()
        trackEvent(ANALYTICS_EVENTS.ONBOARDING_COMPLETED)
      }
      navigate('/')
    } else {
      navigate('/onboarding/linkedin')
    }
    await refetchCurrentUser()
  }

  if(isLoading || submitting) { return <Loading /> }
  return (
    <>
      <OnBoardingHeader title={t('onboarding.news.title')} description={t('onboarding.news.description')} />
      <NewsForm defaultValues={data ?? { optinWhatsapp: false, optinJobOffers: true, favouriteCareerPaths: [] }} onSuccess={onSuccess} />
    </>
  )
}
export default OnboardingNews
